import { Stack } from "@mui/material";
import SelectSupportValue from "../selectSupportValue";
import { makeStyles, TextField, useMediaQuery } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import WalletUseingComponent from "../../../../common/walletUseingComponent/WalletUseingComponent";
import { useRouter } from "next/router";
import { getApiService } from "../../../../../services/AgapeAPI";
import { useTheme } from "@material-ui/core/styles";
import Num2persian from "num2persian";
import CurrencyFormat from "../../../../../services/CurrencyFormat";
import Unseparate from "../../../../../helpers/unseparate";

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#acacac",
    // border: "1px solid #B6B3B3",
    margin: "auto",
    // borderRadius: "30px",
    // border: "1px solid #B6B3B3",
    alignSelf: "center",
    width: "30%",

    height: "40px",
    "&::placeholder": {
      fontSize: "12px",
      fontFamily: "vazir",
    },
    "& .MuiInputBase-root": {
      dir: "ltr",
      height: "58px",
      width: "100%",
      margin: "auto",
      border: "1px solid #B6B3B3",
      borderRadius: "30px",
    },
    "& .MuiFormHelperText-root": {
      color: "red",
      fontSize: "14px",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      margin: 0,
      width: "90%",
    },
    "@media only screen and (min-width: 768px) and (max-width: 1024px)": {
      margin: 3,
      width: "90%",
    },
  },
  chip: {
    "& .MuiChip-root": {
      height: "75%",
      transform: "translate(9px, 0)",
      marginLeft: "8px",
      padding: "3px 26px",
      backgroundColor: "rgb(136 152 170 / 0.21)",
      // borderRadius: "26px",
      color: "#8898aa !important",
      fontSize: "1.181rem",
      fontFamily: "Vazir-Bold",
      boxShadow: "0 1px 3px 0 rgba(50, 50, 93, 0.18)",
    },
  },
}));
const RiyalPayment = () => {
  const [paymentValue, setPaymentValue] = React.useState(50000);
  const [user, setUser] = React.useState();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  React.useEffect(() => {
    if (!user) {
      getApiService("ums/me").then((res) => setUser(res.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  const clasess = useStyles();
  const router = useRouter();
  const handleTabChanged = (value) => {
    setPaymentValue(value);
  };
  return (
    <Stack
      direction={isMobile ? "column" : "row"}
      alignItems={"center"}
      justifyContent={"space-around"}
      // paddingX={"3px"}
      style={{
        backgroundColor: "#FFFFFF",
        height: isMobile ? "300px" : "129px",
        boxShadow: " 0px 0px 46px 13px rgba(0,0,0,0.1)",
        borderRadius: "10px",
        marginTop: "15px",
      }}
    >
      <Stack
        direction={isMobile ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-around"}
        width={isMobile ? "100%" : "93%"}
        height={"100%"}
      >
        <TextField
          helperText={`${
            paymentValue > 0 ? Num2persian(paymentValue) : "صفر"
          }  تومان`}
          value={CurrencyFormat(paymentValue)}
          id="demo-helper-text-misaligned"
          variant="outlined"
          className={clsx(clasess.root)}
          onChange={(e) => handleTabChanged(Unseparate(e.target.value))}
        />
        <SelectSupportValue
          setAmount={setPaymentValue}
          amount={paymentValue}
          handleTabChanged={handleTabChanged}
        />
        <div style={{ width: isMobile ? "93%" : "50%" }}>
          <WalletUseingComponent
            paymentData={{
              amount: paymentValue * 10,
              // ...(intent !== null && intent > 0
              //   ? { intent_id: intent.toString() }
              //   : null),

              organization_id: router.query.id,
            }}
            paymentURL="pay/dedicate-payments"
            amount={paymentValue}
            wallet={user?.wallet?.balance || 0}
            callback={() => router.replace(`/login?from=${router.asPath}`)}
          />
        </div>
      </Stack>
    </Stack>
  );
};

export default RiyalPayment;
